__turbopack_context__.v({
  "aboutbox1": "about-upsc-module__sY-Hja__aboutbox1",
  "aboutheading1": "about-upsc-module__sY-Hja__aboutheading1",
  "aboutheading2": "about-upsc-module__sY-Hja__aboutheading2",
  "aboutnumber": "about-upsc-module__sY-Hja__aboutnumber",
  "aboutoption": "about-upsc-module__sY-Hja__aboutoption",
  "aboutparagraph1": "about-upsc-module__sY-Hja__aboutparagraph1",
  "acheivername": "about-upsc-module__sY-Hja__acheivername",
  "acheivernamespecial": "about-upsc-module__sY-Hja__acheivernamespecial",
  "acheiverrank": "about-upsc-module__sY-Hja__acheiverrank",
  "acheiverrankspecial": "about-upsc-module__sY-Hja__acheiverrankspecial",
  "active": "about-upsc-module__sY-Hja__active",
  "agecontent": "about-upsc-module__sY-Hja__agecontent",
  "classesborder": "about-upsc-module__sY-Hja__classesborder",
  "content": "about-upsc-module__sY-Hja__content",
  "dot": "about-upsc-module__sY-Hja__dot",
  "facultyborder3": "about-upsc-module__sY-Hja__facultyborder3",
  "form-control": "about-upsc-module__sY-Hja__form-control",
  "nav-item": "about-upsc-module__sY-Hja__nav-item",
  "nav-link": "about-upsc-module__sY-Hja__nav-link",
  "nav-pills": "about-upsc-module__sY-Hja__nav-pills",
  "nav-tabs": "about-upsc-module__sY-Hja__nav-tabs",
  "numberbold": "about-upsc-module__sY-Hja__numberbold",
  "pagemaintitle": "about-upsc-module__sY-Hja__pagemaintitle",
  "redunderline": "about-upsc-module__sY-Hja__redunderline",
  "redunderlinealink": "about-upsc-module__sY-Hja__redunderlinealink",
  "sectionredtitle": "about-upsc-module__sY-Hja__sectionredtitle",
  "sectionsubtitle": "about-upsc-module__sY-Hja__sectionsubtitle",
  "sectiontitle": "about-upsc-module__sY-Hja__sectiontitle",
  "show": "about-upsc-module__sY-Hja__show",
  "star": "about-upsc-module__sY-Hja__star",
  "tabactive": "about-upsc-module__sY-Hja__tabactive",
  "tablinks": "about-upsc-module__sY-Hja__tablinks",
  "tabscrollclass": "about-upsc-module__sY-Hja__tabscrollclass",
  "tlitem": "about-upsc-module__sY-Hja__tlitem",
  "tlitem1": "about-upsc-module__sY-Hja__tlitem1",
  "tlitem2": "about-upsc-module__sY-Hja__tlitem2",
  "ulclass": "about-upsc-module__sY-Hja__ulclass",
  "ulliclass": "about-upsc-module__sY-Hja__ulliclass",
  "ullispan": "about-upsc-module__sY-Hja__ullispan",
});
